import React, {useEffect, useRef} from "react";
import {Link} from 'react-router-dom';
import {HttpMethod} from '../../../model';
import {httpClient} from '../../../service';

const QnaTopHtml =  (props: any) => {
    const forumCode = props.forumCode;
   const stepInput= useRef<HTMLAnchorElement>(null);
    const getListCount=async ()=>{
        const url = `boards/${forumCode}/count`;
        const options = {
            method: HttpMethod.GET,
            url
        }
        const act = await httpClient(options);
        if(act.result){
             const boardCnt=act.data;
            if (boardCnt === 0 && stepInput.current !== null) {
                stepInput.current.click();
            }
        }
    };
    useEffect( ()=>{
            getListCount().then(r=>console.log(r));
    },[]);
    return (
        <div className="bloc l-bloc" id="bloc-14">
            <div className="container bloc-sm">
                <div className="row">
                    <div className="col">
                        <Link to={`write/${forumCode}`}
                              className="btn btn-d btn-lg btn-block download-bt" ref={stepInput}>문의하기</Link></div>
                </div>
            </div>
        </div>
    )


}

export default QnaTopHtml;
